<script>
  import { truncate } from "/shared/utils.js";

  export let covidResponse = null;
  export let covidIsCurrentlyOpen; // one of {"None", "True", "False"}
  export let covidOpeningDate;

  let message = truncate(covidResponse, 35); // 7 lines =~ 35 words

  /*
   * Although showButton depends upon the value of a reactive variable,
   * it is not itself reactive as it is not prefixed with $. I.e. its
   * value is set once, during component initialisation.
   */
  let showButton = message != covidResponse;
  let buttonText = "more";

  const toggleFullText = () => {
    if (message != covidResponse) {
      message = covidResponse;
      buttonText = "less";
    } else {
      message = truncate(covidResponse, 35);
      buttonText = "more";
    }
  };
</script>

<style>
  /* Custom button styles: We want an element which functions
   * semantically as a button but is styled as an anchor tag.
   */
  button {
    background: none !important;
    border: none;
    padding-left: 0rem;
    font-weight: 500;
  }
</style>

<div class="card border-0 shadow mb-5">
  <div class="card-body">
    <h5 class="card-title">COVID-19 Update</h5>
    {#if covidIsCurrentlyOpen == "True"}
      <span class="badge badge-primary text-uppercase">Open</span>
    {:else if covidOpeningDate && covidIsCurrentlyOpen == "False"}
      <span class="badge badge-dark text-uppercase">
        Opens on {covidOpeningDate}
      </span>
    {:else if covidIsCurrentlyOpen == "False"}
      <span class="badge badge-dark text-uppercase">Temporarily Closed</span>
    {/if}
    <p class="card-text pt-1">{message}</p>
    {#if showButton}
      <button class="pt-0 text-muted" on:click={toggleFullText}>
        Read {buttonText}
      </button>
    {/if}
  </div>
</div>
